<res-base-modal
    [modalTitle]="modalTitle"
    [modalAutomationId]="modalAutomationId"
    [modalHelpIndex]="modalHelpIndex"
    [verifyRequiredValidator]="verifyRequiredValidator"
    [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="importProject()"
    (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage"
    [resizeHorizontal]="true" [resizeHorizontalMin]="400" [resizeVertical]="true" [resizeVerticalMin]="400" [maximizable]="true">
   
    <res-name-description [automationId]="modalAutomationId" [validateName]="true" [validateNameRequest]="validateNameRequest"></res-name-description>

    <res-data-area-and-tree class="modal-fill" [automationId]="modalAutomationId" (onDAATChange)="onDataAreaAndTreeChange()"></res-data-area-and-tree>
</res-base-modal>
